import { motion, useReducedMotion } from "framer-motion";

// One-time, brief section entrance: small fade with a small upward movement.
export const Reveal = ({ children, delay = 0, y = 20, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ index, children, tone = "light", testId }) => (
  <p
    data-testid={testId}
    className={`text-xs font-bold uppercase tracking-[0.22em] ${
      tone === "light" ? "text-paper/45" : "text-ink/55"
    }`}
  >
    {index && <span className="mr-2 text-lilac-deep">{index}</span>}
    {children}
  </p>
);
